import React, { useState } from "react";
import { Container, Button, Box, CircularProgress, Typography } from "@mui/material";
import { MenuInicial } from "./MenuInicial";
import axios from "axios";
import { API_BASE_URL, ALTACARTAPDF, RUTACARTAPDF } from '../services/apiConfig';
import { registrarLogError, registrarAccion } from '../services/api.js';

function Carta() {
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const usuarioid = userData?.usuarioid;

  const [selectedFile, setSelectedFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  // --- CONFIGURACIÓN DE PESO (en Bytes) ---
  const MAX_FILE_SIZE_MB = 10; 
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

  // Función auxiliar para formatear bytes a algo legible
  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSuccessMessage('');

    if (!file) return;

    // 1. Validar tipo
    if (file.type !== "application/pdf") {
      setError('Por favor, selecciona un archivo PDF.');
      setSelectedFile(null);
      return;
    }

    // 2. Validar tamaño
    if (file.size > MAX_FILE_SIZE_BYTES) {
      setError(`El archivo es demasiado pesado. Máximo permitido: ${MAX_FILE_SIZE_MB}MB`);
      setSelectedFile(file); // Lo guardamos para mostrar el peso, pero el botón debería validarlo
    } else {
      setError('');
      setSelectedFile(file);
    }
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      setError('Por favor, selecciona un archivo PDF.');
      return;
    }

    // Doble validación antes de subir
    if (selectedFile.size > MAX_FILE_SIZE_BYTES) {
      setError('No puedes subir este archivo porque excede el límite.');
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setIsUploading(true);
    try {
      const response = await axios.post(API_BASE_URL + ALTACARTAPDF, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "success") {
        setPdfUrl(response.data.url);
        setError('');
        await registrarAccion(usuarioid, ` se subio correctamente el pdf `);
        setSuccessMessage('¡El archivo se subió exitosamente!');
        setSelectedFile(null); // Limpiar selección tras éxito
      } else {
        setError(`La subida falló: ${response.data.message}`);
        registrarLogError(usuarioid, 'Carta', response.status + ' - ' + response.data.message);
      }
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      setError(error.response?.data?.message || 'Error de conexión con el servidor.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Container>
      <MenuInicial />

      <Box mt={4} display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Box>
          <input 
            type="file" 
            style={{ display: 'none' }} 
            accept="application/pdf" 
            onChange={handleFileChange} 
            id="upload-file" 
          />
          <label htmlFor="upload-file">
            <Button variant="contained" component="span" color="inherit">
              {selectedFile ? "Cambiar Archivo" : "Seleccionar PDF"}
            </Button>
          </label>
        </Box>

        {selectedFile && (
          <Box textAlign="center">
            <Typography variant="body2">
              <strong>Archivo:</strong> {selectedFile.name}
            </Typography>
            <Typography variant="caption" color={selectedFile.size > MAX_FILE_SIZE_BYTES ? "error" : "textSecondary"}>
              Tamaño: {formatBytes(selectedFile.size)} / {MAX_FILE_SIZE_MB}MB
            </Typography>
          </Box>
        )}

        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleFileUpload}
          disabled={isUploading || !selectedFile || selectedFile.size > MAX_FILE_SIZE_BYTES}
        >
          {isUploading ? "Subiendo..." : "Subir PDF"}
        </Button>

        {isUploading && <CircularProgress size={24} style={{ marginTop: '8px' }} />}
        
        {error && (
          <Typography color="error" variant="body2" style={{ marginTop: '8px', fontWeight: 'bold' }}>
            {error}
          </Typography>
        )}
        
        {successMessage && (
          <Typography style={{ color: 'green', marginTop: '8px' }}>
            {successMessage}
          </Typography>
        )}
      </Box>

      {RUTACARTAPDF && (
        <Box mt={4} display="flex" justifyContent="center">
          <Button variant="outlined" color="primary" href={RUTACARTAPDF} target="_blank" rel="noopener noreferrer">
            Ver PDF Actual
          </Button>
        </Box>
      )}
    </Container>
  );
}

export default Carta;